import React from 'react';
import Accordion from 'react-bootstrap/Accordion';

/**
 * TODO: configure "flush" & other configs
 */
const AccordionComponent = ({ accordionItems }) => {
  return (
    <Accordion flush> 
      {accordionItems.map((accordionItem, index) =>
        <Accordion.Item eventKey={index}>
          <Accordion.Header className="accordion-header-title">
            {accordionItem.title}
          </Accordion.Header>
          <Accordion.Body>
            <section dangerouslySetInnerHTML={{ __html:  accordionItem.content }} itemProp="accordionItemContent" />
          </Accordion.Body>
        </Accordion.Item>
      )}
    </Accordion>);
};

export default AccordionComponent;
